import { useInlineStatusMutation } from "@octopusdeploy/octopus-react-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { useState } from "react";
import type { ActionEvent } from "~/analytics/Analytics";
import { Action, useAnalyticActionDispatch, useAnalyticTrackedActionDispatch } from "~/analytics/Analytics";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import { required, Text } from "~/components/form";
interface AddEphemeralEnvironmentsDialogProps {
    projectId: string;
    spaceId: string;
    saveDone: (environment: {
        Id: string;
    }) => Promise<void>;
}
export function AddEphemeralEnvironmentsDialog(props: AddEphemeralEnvironmentsDialogProps) {
    const dispatchAction = useAnalyticActionDispatch();
    const trackAction = useAnalyticTrackedActionDispatch();
    const [environmentName, setEnvironmentName] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [error, setError] = useState<Error | undefined>();
    const { execute: createEphemeralEnvironment } = useInlineStatusMutation({
        name: "Create ephemeral environment",
        action: async (repository) => {
            const ev: ActionEvent = {
                action: Action.Add,
                resource: "Ephemeral Environment",
            };
            return await trackAction("Save Ephemeral Environment", ev, async () => {
                const result = await repository.EphemeralEnvironments.create({
                    SpaceId: props.spaceId,
                    ProjectId: props.projectId,
                    EnvironmentName: environmentName,
                });
                return result;
            });
        },
        afterComplete: async (_, result) => {
            setIsCreating(false);
            await props.saveDone({ Id: result.Id });
        },
        onError: (error) => {
            setIsCreating(false);
            setError(error);
        },
    });
    const saveEphemeralEnvironment = async (): Promise<boolean> => {
        setIsCreating(true);
        setError(undefined);
        await createEphemeralEnvironment();
        return true;
    };
    const handleCancelClick = () => {
        dispatchAction("Cancel Adding Environment", {
            resource: "Ephemeral Environment",
            action: Action.Cancel,
        });
        return true; // Return true so the dialog will auto-close still.
    };
    return (<SaveDialogLayout title="Add Ephemeral Environment" busy={isCreating} errors={error ? [error] : []} savePermission={{ permission: Permission.EnvironmentCreate, environment: "*" }} onSaveClick={saveEphemeralEnvironment} onCancelClick={handleCancelClick}>
            <Text label="Environment name" value={environmentName} onChange={setEnvironmentName} autoFocus={true} validate={required("Please enter an environment name")}/>
        </SaveDialogLayout>);
}
